<script lang="ts">
  import { locationSearchQuery } from '$lib/stores/search';
  import { t } from '$lib/translations';
</script>

<div class="input-wrapper relative">
  <div class="search-icon-wrapper">
    <svg
      aria-hidden="true"
      class="search-icon"
      fill="currentColor"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      ><path
        fill="currentColor"
        fill-rule="evenodd"
        d="M8 4a4 4 0 1 0 0 8a4 4 0 0 0 0-8ZM2 8a6 6 0 1 1 10.89 3.476l4.817 4.817a1 1 0 0 1-1.414 1.414l-4.816-4.816A6 6 0 0 1 2 8Z"
        clip-rule="evenodd"
      /></svg
    >
  </div>
  <input
    type="search"
    bind:value={$locationSearchQuery}
    placeholder="{ $t('content.searchPlaceholder') }"
    class="form-input search-input"
  />
</div>

<style lang="postcss">
  .input-wrapper {
    @apply w-full my-4;
  }

  .search-icon-wrapper {
    @apply absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none;
  }

  .search-icon {
    @apply w-4 h-4 text-gray-500 dark:text-gray-400;
  }

  .search-input {
    @apply block w-full py-2 px-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg focus:ring-gray-400;
  }
</style>
